<template lang="pug">
#modal-visualizacao-cars-vinculados-monitoramento-socioambiental
    el-dialog(
        :title="$t('mensagens.comuns.carsVinculados')",
        width='645px',
        :visible.sync='showCarsVinculadosSocioambiental',
        @close='changeShowCarsVinculadosSocioambientalModal'
    )
        .bloco-dados
            el-table(
                style='width: 100%; height: 100%',
                :data='cars'
            )
                el-table-column(:label="$t('mensagens.comuns.numeroDoCAR')", width='450')
                    template(slot-scope='scope')
                        span {{ scope.row.codigo }}
                el-table-column(:label="$t('mensagens.comuns.monitoramento.situacaoCAR')", width='150')
                    template(slot-scope='scope')
                        span.condicao-ativo(
                            v-if='scope.row.condicao === "AT"') {{ validaSituacao(scope.row.condicao) }}
                        span.condicao-pendente(
                            v-else-if='scope.row.condicao === "PE"') {{ validaSituacao(scope.row.condicao) }}
                        span.condicao-suspenso(
                            v-else-if='scope.row.condicao === "SU"') {{ validaSituacao(scope.row.condicao) }}
                        span.condicao-cancelado(
                            v-else) {{ validaSituacao(scope.row.condicao) }}
                        el-tooltip(
                            class='item',
                            effect='dark',
                            placement='top-end')
                            div(slot='content')
                                span {{ $t('mensagens.monitoramentoAgricola.blocoCarsVinculados.statusAnterior') }} {{ validaSituacao(scope.row.statusAnterior) }}
                                br
                                span {{ $t('mensagens.monitoramentoAgricola.blocoCarsVinculados.ultimaAtualizacao') }} {{ scope.row.dataUltimaAtualizacao }}
                            i.ml-3.flow.flow-warning-sign.laranja(v-if="scope.row.statusAnterior")

</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import StatusCar from '@/constants/StatusCar';

export default {
    name: 'ModalVisualizacaoCarsVinculadosMonitoramentoSocioambiental',
    props: {
        cars: {
            type: Array,
            required: true,
            default: null
        },
        monitoramento: {
            type: Object,
            required: true,
            default: null
        }
    },

    computed: {
        ...mapGetters(['showCarsVinculadosSocioambiental'])
    },

    data() {
        return {};
    },

    methods: {
        ...mapActions(['changeShowCarsVinculadosSocioambientalModal']),

        validaSituacao(situacao) {
            return StatusCar[situacao];
        }
    }
};
</script>
<style lang="scss">
#modal-visualizacao-cars-vinculados-monitoramento-socioambiental {
    display: flex;

    .bloco-dados {
        display: flex;
        position: relative;
        overflow-y: auto;
    }

    .condicao-ativo {
        color: var(--secondary-two);
    }

    .condicao-pendente {
        color: var(--car-pendente-color);
    }

    .condicao-suspenso {
        color: var(--car-suspenso-color);
    }

    .condicao-cancelado {
        color: var(--danger);
    }

    .el-table__body-wrapper {
        overflow-y: auto;
        height: 340px;
    }

    .el-dialog__header {
        background-color: var(--default-background-color);
    }

    .estilo-icone {
        margin-left: 10px;
        font-size: large;
    }

    .estilo-popover {
        background-color: var(--dark) !important;
        color: var(--white) !important;
    }

    .el-dialog__body {
        padding: 0px 20px;
    }

    .el-dialog__title {
        color: var(--primary);
        font-weight: bold;
    }

    .laranja {
        color: #f88342;
    }
}
</style>
